module.exports = __webpack_public_path__ + "img/erweima.95d4c61f.png";